export default "__VITE_ASSET__CI_0vNXH__"